var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c("div", [
                    _c(
                      "span",
                      { staticStyle: { color: "#2eabff", width: "30px" } },
                      [_vm._v("|")]
                    ),
                    _c("span", [_vm._v("基础信息")])
                  ]),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "物业公司法人",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "propertyCorporation"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入物业公司法人" },
                            model: {
                              value: _vm.model.propertyCorporation,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "propertyCorporation", $$v)
                              },
                              expression: "model.propertyCorporation"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "物业单位名称",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "propertyName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入物业单位名称" },
                            model: {
                              value: _vm.model.propertyName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "propertyName", $$v)
                              },
                              expression: "model.propertyName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("div", [
                    _c(
                      "span",
                      { staticStyle: { color: "#2eabff", width: "30px" } },
                      [_vm._v("|")]
                    ),
                    _c("span", [_vm._v("添加客户")])
                  ]),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "公司法人",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "corporation"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入公司法人" },
                            model: {
                              value: _vm.model.corporation,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "corporation", $$v)
                              },
                              expression: "model.corporation"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "单位名称",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "name"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入单位名称" },
                            model: {
                              value: _vm.model.name,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "name", $$v)
                              },
                              expression: "model.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "厂区-区域-楼栋",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "treeData"
                          }
                        },
                        [
                          _c("a-tree-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "tree-data": _vm.treeData,
                              "tree-checkable": "",
                              "allow-clear": "",
                              "show-checked-strategy": _vm.SHOW_PARENT,
                              placeholder: "请选择厂区-区域-楼栋"
                            },
                            on: {
                              treeExpand: _vm.handlerTreeExpand,
                              change: _vm.handlerChange,
                              select: _vm.handlerSelect
                            },
                            model: {
                              value: _vm.model.treeData,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "treeData", $$v)
                              },
                              expression: "model.treeData"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "系统账号",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "principalId"
                          }
                        },
                        [
                          _c("a-select", {
                            attrs: {
                              placeholder: "请选择系统账号",
                              options: _vm.sysAccountOptions,
                              disabled: _vm.isDisabled,
                              allowClear: ""
                            },
                            on: { change: _vm.handleAccoutChange },
                            model: {
                              value: _vm.model.principalId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "principalId", $$v)
                              },
                              expression: "model.principalId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "负责人",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "principalName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入负责人" },
                            model: {
                              value: _vm.model.principalName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "principalName", $$v)
                              },
                              expression: "model.principalName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "手机号码",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "principalMobile"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入手机号码" },
                            model: {
                              value: _vm.model.principalMobile,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "principalMobile", $$v)
                              },
                              expression: "model.principalMobile"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "邮箱",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "principalEmail"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入邮箱" },
                            model: {
                              value: _vm.model.principalEmail,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "principalEmail", $$v)
                              },
                              expression: "model.principalEmail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }